import styled from "styled-components";
import {ButtonCustomWithDarkText} from "../Style/Style";

interface IErrorButtonProps {
  error?: boolean
}

export const LanguageButton = styled(ButtonCustomWithDarkText)<IErrorButtonProps>`
  background-color: ${props => props.error && 'red'} !important;
`;